export const APP_NAME = "YourCV";

export const RESUME_LIMITS = {
  free: 2,
  pro: 100,
} as const;

export const STORAGE_LIMITS = {
  free: 20 * 1024 * 1024,
  pro: 200 * 1024 * 1024,
} as const;

export const SECTION_LIMITS = 50;
export const ORGANIZATION_SEAT_LIMIT = 500;
export const ORGANIZATION_INVITE_DAYS = 7;
export const APP_PASSWORD_LIMIT = 10;
export const APP_PASSWORD_MAX_DAYS = 365;
export const APP_PASSWORD_DEFAULT_DAYS = 90;

export const APP_PASSWORD_SCOPES = [
  "resumes:read",
  "resumes:write",
  "resumes:publish",
  "assets:write",
] as const;

export type AppPasswordScope = (typeof APP_PASSWORD_SCOPES)[number];

export const VISIBILITIES = ["private", "unlisted", "public"] as const;
export type Visibility = (typeof VISIBILITIES)[number];

export const UI_LOCALES = ["en", "vi"] as const;
export type UiLocale = (typeof UI_LOCALES)[number];

export const CV_LOCALES = ["en", "vi"] as const;
export type CvLocale = (typeof CV_LOCALES)[number];

export const PAGE_SIZES = ["a4", "letter"] as const;

export const LINK_TYPES = [
  "linkedin",
  "github",
  "website",
  "portfolio",
  "email",
  "custom",
] as const;

export const EMPLOYMENT_TYPES = [
  "full-time",
  "part-time",
  "contract",
  "internship",
  "freelance",
] as const;

export const PROFICIENCY = ["native", "fluent", "professional", "limited"] as const;
